/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import Arrows from '../../www/assets/images/arrows_select_box.svg';

import '../../www/assets/css/dropdown.css';

/**
 * Dropdown is a stateless leaf node.
 * Without local state, when passing the onItemClick, it's important that the parent triggers the re-render onChange
 */
const Dropdown = ({ itemList, itemIndex = 0, onItemClick, customPlaceholder = null, style = {} }) => {
	const value = itemList[itemIndex] ? itemList[itemIndex]?.text : customPlaceholder;

	return (
		<div className='dropdownds' style={style}>
			<div className='main grid-position'>
				<label>{value}</label>
				<Arrows className='svg icon' />
			</div>
			<select
				className='select-style grid-position'
				value={value}
				onChange={e => {
					const index = itemList.findIndex(({ text }) => text === e.target.value);
					onItemClick(index, e.target.value);
				}}
			>
				{
					customPlaceholder
				&& <option disabled hidden value={value}>{value}</option>
				}
				{ itemList.map(({ id, text }) => (text ? (<option key={id.toString()} value={text}>{text}</option>) : null)) }
			</select>
		</div>
	);
};

Dropdown.propTypes = {
	style: PropTypes.shape({}),
	itemList: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		text: PropTypes.string
	})).isRequired,
	itemIndex: PropTypes.number,
	className: PropTypes.string,
	onItemClick: PropTypes.func.isRequired
};

export default Dropdown;
